import * as moment from 'moment';
import { Moment } from 'moment';

export class PlantForcedCheckin {
  actualLatitude: number;
  actualLongitude: number;
  expectedLatitude: number;
  expectedLongitude: number;
  date: Moment;
  loadId: string;
  shipmentNumbers: string;
  glid: string;
  vehicleId: string;

  static fromDto(p: any): PlantForcedCheckin {
    const res = new PlantForcedCheckin();

    res.actualLatitude = p.actual_latitude;
    res.actualLongitude = p.actual_longitude;
    res.expectedLatitude = p.expected_latitude;
    res.expectedLongitude = p.expected_longitude;
    res.date = p.date ? moment(p.date) : null;
    res.loadId = p.load_id;
    res.shipmentNumbers = p.shipment_numbers;
    res.glid = p.glid;
    res.vehicleId = p.vehicle_id;

    return res;
  }

  static entitiesFromDto(p: any): PlantForcedCheckin[] {
    const res = [];
    p.forEach((dto) => {
      res.push(this.fromDto(dto));
    })

    return res;
  }
}
